import '@kerfjs/ui/select/register';

import { List } from '@kerfjs/ui/list';
import { Select } from '@kerfjs/ui/select';
import { StateBanner } from '@kerfjs/ui/state-banner';
import { Text } from '@kerfjs/ui/text';
import { type SafeHtml } from 'kerfjs';

import { me, notice } from '../../../data/state.js';

export function PersonalSettingsView(): SafeHtml {
  const prefs = me.value?.preferences ?? {};
  const grouping = typeof prefs.numberGrouping === 'string' ? prefs.numberGrouping : 'org';
  const orgGrouping = me.value?.orgNumberGrouping === 'international' ? 'international' : 'pakistani';
  const orgLabel = orgGrouping === 'pakistani' ? 'Pakistani (12,50,000)' : 'International (1,250,000)';
  return (
    <List gap="l" controlInsets="trbl" className="personal-settings-view">
      <List>
        <Select<string>
          name="pref-grouping"
          label="Number Grouping"
          value={grouping}
          choices={[
            { value: 'org', label: `Organization Default (${orgLabel})` },
            { value: 'international', label: 'International (1,250,000)' },
            { value: 'pakistani', label: 'Pakistani (12,50,000)' },
          ]}
        />
        <Text tone="quiet" size="compact">
          Overrides how grouped figures are shown to you across the app.
        </Text>
      </List>
      {notice.value !== '' ? <StateBanner tone="info" title={notice.value} /> : null}
    </List>
  );
}
